import 'twin.macro'

import { SerializedStyles } from '@emotion/react'
import { ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

import Typography from '../Typography'

export type ConditionProps = {
  caption: ReactNode
  body: ReactNode
  icon?: ReactNode
  footer?: ReactNode
  twStyle?: TwStyle | SerializedStyles
}

const ConditionBlock = ({ body, caption, icon, footer, twStyle }: ConditionProps) => {
  return (
    <div css={[tw`p-4 flex items-center space-x-2`, twStyle]}>
      <div tw='rounded-[100px] bg-stroke w-[20px] h-[20px] flex items-center justify-center'>{icon}</div>
      <div>
        <Typography variant='caption' twStyle={tw`text-grey-dark`}>
          {caption}
        </Typography>
        <Typography variant='body' weight='bold'>
          {body}
        </Typography>
      </div>
      {footer}
    </div>
  )
}

export default ConditionBlock
